<template>
  <div class="starred-list">
    <h1 class="project-section-title">{{ title }}</h1>
    <div class="starred-list-container">
      <div v-for="(item, index) in items" :key="index" class="starred-item">
        <div class="starred-item-card" @click="$emit('open', items[index])">
          <a
            v-if="canStarr"
            class="starred-button icon icon-starred-fill"
            @click.stop="$emit('starred', items[index])"
          ></a>
          <div class="thumb" :class="thumbnail(item)"></div>
        </div>
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StarredList',
  props: {
    items: {
      type: Array
    },
    title: {
      type: String
    },
    canStarr: {
      type: Boolean
    }
  },
  methods: {
    isImage(extension) {
      const imageExtensions = ['jpg', 'jpeg', 'gif', 'png'];
      return imageExtensions.includes(extension);
    },
    thumbnail(file) {
      const fileName = file.fileName;
      let extension = '';
      if (fileName) {
        extension = fileName.substr(fileName.lastIndexOf('.') + 1);
      }
      extension = extension.toLowerCase();

      if (this.isImage(extension)) {
        return 'icon icon-img';
      } else if (extension == 'pdf') {
        return 'icon icon-pdf';
      } else if (extension == 'zip') {
        return 'icon icon-zip';
      } else if (
        [
          '3gp',
          '3g2',
          'avi',
          'flv',
          'm4p',
          'm4v',
          'mov',
          'mp2',
          'mp4',
          'mpe',
          'mpeg',
          'mpg',
          'mpv',
          'mts',
          'ogg',
          'qt',
          'svi',
          'webm',
          'wmv'
        ].includes(extension)
      ) {
        return 'icon icon-movie';
      } else if (['ppt', 'keynote', 'pptx'].includes(extension)) {
        return 'icon icon-ppt';
      } else if (['doc', 'docx', 'txt'].includes(extension)) {
        return 'icon icon-Document';
      } else {
        return 'icon icon-link';
      }
    }
  }
};
</script>

<style scoped lang="scss">
.starred-list-container {
  display: flex;
  flex-wrap: wrap;

  .starred-item {
    margin: 4px;

    .starred-item-card {
      border-radius: $radius;
      width: 95px;
      height: 95px;
      background: rgba(0, 0, 0, 0.15);
      margin-bottom: 4px;
      position: relative;
    }

    .title {
      font-size: 1.3rem;
      height: 28px;
      width: 95px;
      overflow: hidden;
      text-align: center;
    }

    .starred-button {
      font-size: 1.5rem;
      position: absolute;
      top: 10px;
      left: 10px;
    }

    .thumb {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
</style>
